

export function onKeyPress(evt: React.KeyboardEvent<any>): boolean {
	return evt.key === 'Enter' || evt.key === 'Space' || evt.key === ' ';
}